<template>
  <div>
    <h1 class="mb-8 text-3xl font-bold">
      Utwórz blok: {{ kindLabel }}
    </h1>
    <div v-if="templates.length === 0" class="rounded-sm bg-white p-8 text-center shadow-sm">
      <p class="text-gray-600">
        Brak szablonów dla kategorii „{{ kindLabel }}”.
      </p>
    </div>
    <div v-else class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      <div
        v-for="template in templates"
        :key="template.id"
        class="cursor-pointer overflow-hidden rounded-lg bg-white shadow-sm transition-shadow hover:shadow-md"
        @click="selectTemplate(template)"
      >
        <div class="p-6">
          <h3 class="mb-2 text-lg font-semibold text-gray-900">
            {{ template.name }}
          </h3>
          <p class="mb-4 text-sm text-gray-600">
            {{ template.schema?.fields?.length || 0 }} pól
          </p>
          <div class="flex items-center justify-end">
            <icon
              name="cheveron-right"
              class="h-5 w-5 fill-gray-400"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createLayoutHelper } from '@/utils/layoutHelper';

export default {
  layout: createLayoutHelper,
};
</script>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { router } from '@inertiajs/vue3';
import Icon from '@/Shared/Icon.vue';
import { blockKindLabelPl } from '@/utils/blockKindLabels';
import { getBuildBlockRoute } from '@/utils/createBlockRouteHelper';

const { proxy } = getCurrentInstance();
const routes = proxy.$routes;

const props = defineProps({
  templates: {
    type: Array,
    required: true,
  },
  kind: {
    type: String,
    default: null,
  },
  // eslint-disable-next-line vue/prop-name-casing
  site_context: {
    type: String,
    default: null,
  },
});

const kindLabel = computed(() => blockKindLabelPl(props?.kind));

const selectTemplate = (template) => {
  router.visit(getBuildBlockRoute(routes, props.site_context, template.id));
};
</script>
